<div style="text-align: center;">
    <h2 >{{titulo}}</h2>
    <mat-spinner *ngIf="!response" style="margin: auto;" class="mat-spinner-color"></mat-spinner>
    <img *ngIf="response" style="height: 30%;width: 30%;" src={{path}} alt=""><br>
    <span style="color: red;">{{message}}</span><br>
    <button *ngIf="boton" (click)="cerrar()" type="submit" style="background-color: goldenrod;color: black;" class="btn btn-primary mt-2 mt-md-3 mt-lg-4">Cerrar</button>
</div>


